import { Button, Card, Form } from "react-bootstrap"
import { useFormik } from "formik"
import ButtonLoader from "../../loader/ButtonLoader"
import logo from '../../../assets/images/alexa-logo.jpg'
import Text from "../../input_fields/Text"
import SelectBox from "../../input_fields/SelectBox"
import DatePicker from "../../input_fields/DatePicker"
import Number from "../../input_fields/Number"
import Email from "../../input_fields/Email"
import Password from "../../input_fields/Password"
import File from "../../input_fields/File"
import { UserSignupSchema } from "./ValidationSchema"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { signUp } from "../../../redux/slices/assets/SignUp"
import addUpdateHandler from "../../../utils/addUpdateHandler"
import { useTranslation } from "react-i18next"

export const SignupFormImport = {
    Button,
    Card,
    Form,
    Text,
    SelectBox,
    DatePicker,
    Number,
    Email,
    Password,
    File,
    useFormik,
    logo,
    UserSignupSchema,
    ButtonLoader,
    useDispatch,
    useNavigate,
    signUp,
    addUpdateHandler,
    useTranslation
}